import { createAsyncAction } from 'typesafe-actions';

import {
  AllUsersTypes,
  PendingApprovalTypes,
  UserReviewersTypes,
} from './types';

export const getAllUser = createAsyncAction(
  'users/getAllUsers/request',
  'users/getAllUsers/success',
  'users/getAllUsers/failure',
)<undefined, { data: AllUsersTypes[] }, undefined>();

export const getPendingApproval = createAsyncAction(
  'users/getPendingApproval/request',
  'users/getPendingApproval/success',
  'users/getPendingApproval/failure',
)<undefined, { data: PendingApprovalTypes[] }, undefined>();

export const getUserReviewer = createAsyncAction(
  'users/getUserReviewer/request',
  'users/getUserReviewer/success',
  'users/getUserReviewer/failure',
)<undefined, { data: UserReviewersTypes[] }, undefined>();

export const approveUsers = createAsyncAction(
  'users/approveUsers/request',
  'users/approveUsers/success',
  'users/approveUsers/failure',
)<undefined, undefined, undefined>();

export const rejectUsers = createAsyncAction(
  'users/rejectUsers/request',
  'users/rejectUsers/success',
  'users/rejectUsers/failure',
)<undefined, undefined, undefined>();
